// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2jkb8","alertIcon":"ConfirmModal_alertIcon__3TKhD"};